<template>
  <section id="step-two">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <!-- Register -->
          <v-row>
            <v-col
              align="center"
              justify="center"
              cols="12"
              sm="12"
              class="white--text mt-8"
            >
              <h1 class="mt-5 font-weight-bold display-2 mb-2">
                Step 2: Submit
              </h1>
              <h1 class="font-weight-light mb-2">
                On your registration day, browse to one of your favorite
                schedules and just click register.
              </h1>
            </v-col>
            <v-row class="text-center mt-2 mb-3">
              <v-col
                lg="3"
                xs="12"
                v-for="(itemRegis, index) in regisScreen"
                :key="'regis' + index"
              >
                <div>
                  <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                    <span class="white--text text-h6">{{ itemRegis.no }}</span>
                  </v-avatar>
                </div>
                <mobileframe title="Create Plans" :name="itemRegis.img">
                  <div style="color: white">
                    <strong>{{ itemRegis.title }}</strong>
                  </div>
                  <div class="text--primary">
                    <span
                      style="color: white"
                      v-html="itemRegis.description"
                    ></span>
                  </div>
                </mobileframe>
              </v-col>
            </v-row>
          </v-row>
          <div
            style="color: orange"
            class="text-center text-h4 font-weight-bold mt-3"
          >
            <!-- What to do when my registration did not go through? -->
            If your registration does <em>not</em> go through...
          </div>
          <v-row>
            <v-col cols="10" offset="1">
              <div class="text-center mt-3" style="color: white">
                If your registration does <em>not</em> go through, try again
                with a different schedule. Your request might be rejected due to
                a number of reasons, for example, the sections you want just ran
                out of seats, your schedule does not have all the courses you
                are required to take this term, or your schedule did not meet
                the credit requirements, etc.
              </div>
            </v-col>
          </v-row>
          <!-- error -->
          <v-row class="text-center mt-5 mb-3" justify="center">
            <v-col
              lg="4"
              xs="12"
              v-for="(itemError, index) in errorScreen"
              :key="'error' + index"
            >
              <mobileframe :title="itemError.no" :name="itemError.img">
                <div style="color: white">
                  {{ itemError.description }}
                </div>
              </mobileframe>
            </v-col>
          </v-row>
          <div class="mb-2 text-center">
            <v-btn
              color="blue darken-4"
              dark
              @click="$vuetify.goTo('#step-three')"
            >
              Next Step
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import mobileframe from "@/components/shared/MobileFrame";
export default {
  components: {
    mobileframe,
  },
  data: () => ({
    regisScreen: [
      {
        no: "1",
        img: "bg-regis-00",
        title: "Registration from created plan",
        description:
          "To begin for registration, navigate to the <strong>“Planner”</strong> menu.",
      },
      {
        no: "2",
        img: "bg-regis-01",
        title: "Begin Registration",
        description:
          "To register, tap the <strong>“Register”</strong> button from one of your favorite schedules, or directly from the generated schedules screen.",
      },
      {
        no: "3",
        img: "bg-regis-02",
        title: "Confirm Your Courses",
        description:
          "Make sure this selection is correct and click <strong>“Continue”</strong> to confirm your registration.",
      },
      {
        no: "4",
        img: "bg-regis-03",
        title: "Registration Confirmed",
        description:
          "If the registration is successful, you will be directed to the registration result screen. At this point, , you can make unlimited changes to your schedule at no cost.”",
      },
    ],
    errorScreen: [
      {
        no: "",
        img: "bg-error-01",
        title: "",
        description: "One of your selected sections is already full.",
      },
      {
        no: "",
        img: "bg-error-02",
        title: "",
        description:
          "You registered outside your designated registration time window.",
      },
    ],
  }),
};
</script>

<style scoped>
#step-two {
  background-image: url("~@/assets/img/bgDownload.jpg");
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* height: 100%; */
}
#step-two .container,
#step-two .row {
  height: 100%;
}
</style>